/* ===== MyoPulse — micro-interactions premium =====
   Révélation au scroll, tilt 3D léger, anneaux de pulsation ambiants,
   et écran d'entrée premium sur la page d'accueil. Vanilla JS, aucune
   dépendance externe, respecte prefers-reduced-motion. */
(function () {
  "use strict";

  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  /* L'écran d'entrée doit être injecté AVANT le premier paint (pas
     d'attente de DOMContentLoaded) pour éviter tout flash de contenu
     avant l'intro — donc appelé immédiatement, hors de ready(). */
  initIntro();

  ready(function () {
    initScrollReveal();
    initTilt();
    initPulseField();
    initMarquee();
    initTextReveal();
    initCartTimer();
    initReviewRotator();
    initDeliveryEstimate();
  });

  /* ---------- Écran d'entrée premium (accueil uniquement) ---------- */
  function initIntro() {
    if (prefersReducedMotion) return;
    if (window.location.pathname !== "/") return;

    var already;
    try {
      already = window.sessionStorage.getItem("mp-intro-shown");
    } catch (e) {
      already = null;
    }
    if (already) return;

    try {
      window.sessionStorage.setItem("mp-intro-shown", "1");
    } catch (e) {
      /* stockage indisponible : on affiche quand même l'intro une fois,
         tant pis si elle se répète sur cette session */
    }

    var intro = document.createElement("div");
    intro.className = "mp-intro";
    intro.setAttribute("aria-hidden", "true");
    intro.innerHTML =
      '<div class="mp-intro__mark">' +
      '<span class="mp-intro__ring"></span>' +
      '<span class="mp-intro__ring"></span>' +
      '<span class="mp-intro__ring"></span>' +
      "M</div>";

    function mount() {
      document.documentElement.style.overflow = "hidden";
      document.body.appendChild(intro);
      setTimeout(function () {
        intro.classList.add("mp-intro--out");
        document.documentElement.style.overflow = "";
        setTimeout(function () {
          if (intro.parentNode) intro.parentNode.removeChild(intro);
        }, 650);
      }, 1300);
    }

    if (document.body) {
      mount();
    } else {
      document.addEventListener("DOMContentLoaded", mount);
    }
  }

  /* ---------- Anneaux de pulsation ambiants (toutes les pages) ----------
     Une seule couche fixe, injectée une fois, visible sur toutes les
     pages — remplace l'ancien système d'étoiles dupliqué section par
     section. C'est ce qui garantit un rendu identique et sans coupure
     entre les pages. */
  function initPulseField() {
    if (prefersReducedMotion) return;
    if (document.querySelector(".mp-pulse-field")) return;

    var field = document.createElement("div");
    field.className = "mp-pulse-field";

    var rings = [
      { top: "8%", left: "78%", size: 220, delay: "0s", variant: "" },
      { top: "62%", left: "10%", size: 260, delay: "1.4s", variant: " mp-pulse-ring--mint" },
      { top: "35%", left: "92%", size: 160, delay: "2.8s", variant: "" },
      { top: "18%", left: "14%", size: 190, delay: "0.7s", variant: " mp-pulse-ring--mint" },
      { top: "78%", left: "70%", size: 230, delay: "2.1s", variant: "" },
      { top: "48%", left: "48%", size: 300, delay: "3.5s", variant: " mp-pulse-ring--mint" },
    ];

    rings.forEach(function (r) {
      var ring = document.createElement("span");
      ring.className = "mp-pulse-ring" + r.variant;
      ring.style.top = r.top;
      ring.style.left = r.left;
      ring.style.width = r.size + "px";
      ring.style.height = r.size + "px";
      ring.style.marginLeft = -(r.size / 2) + "px";
      ring.style.marginTop = -(r.size / 2) + "px";
      ring.style.animationDelay = r.delay;
      field.appendChild(ring);
    });

    document.body.insertBefore(field, document.body.firstChild);
  }

  /* ---------- Révélation au scroll ---------- */
  function initScrollReveal() {
    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      return;
    }

    /* Comparaison par suffixe : l'id réel des sections porte un
       préfixe numérique de template/groupe (template--123__xxx), donc
       un id exact ne matche jamais rien. On exclut header + barre
       d'annonce, qui doivent rester visibles immédiatement. */
    var excludedSuffixes = ["__header", "__announcement_bar_WjRH8c"];

    var sections = Array.prototype.slice
      .call(document.querySelectorAll('[id^="shopify-section-"]'))
      .filter(function (el) {
        return !excludedSuffixes.some(function (suffix) {
          return el.id.indexOf(suffix) !== -1;
        });
      });

    if (!sections.length) return;

    /* threshold quasi nul : sur une section haute (fiche produit
       "main", bien plus grande que le viewport), exiger un pourcentage
       de SA PROPRE surface visible peut ne jamais être atteint — la
       section restait alors invisible en permanence. */
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mp-in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -5% 0px" }
    );

    sections.forEach(function (section) {
      section.classList.add("mp-reveal-pending");
      observer.observe(section);
    });

    /* Filet de sécurité : si une section reste "pending" (cas limite),
       on la révèle quand même après quelques secondes. */
    setTimeout(function () {
      document
        .querySelectorAll(".mp-reveal-pending:not(.mp-in-view)")
        .forEach(function (el) {
          el.classList.add("mp-in-view");
        });
    }, 2500);
  }

  /* ---------- Tilt 3D léger au survol ---------- */
  function initTilt() {
    if (prefersReducedMotion || !window.matchMedia("(pointer: fine)").matches) {
      return;
    }

    var selectors = [
      ".mp-icon-badge",
      '[id$="__pp_image_with_text_HNW9yr"] img',
      '[id$="__pp_image_with_benefits_YnG9hi"] img',
      '[id$="__pp_image_with_benefits_gkXTTj"] img',
      '[id$="__pp_image_with_text_BVEaDq"] img',
      '[id$="__pp_image_with_percentage_fLf47C"] img',
      '[id$="__pp_image_with_text_Mwp9Hi"] img',
      '[id$="__pp_image_with_text_ttLHQy"] img',
      '[id$="__pp_image_with_text_xd44KG"] img',
    ];

    var targets = document.querySelectorAll(selectors.join(","));
    if (!targets.length) return;

    targets.forEach(function (el) {
      el.classList.add("mp-tilt");

      var raf = null;
      var maxTilt = el.classList.contains("mp-icon-badge") ? 14 : 6;

      el.addEventListener("mousemove", function (e) {
        var rect = el.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;

        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.transform =
            "perspective(800px) rotateX(" +
            (-y * maxTilt).toFixed(2) +
            "deg) rotateY(" +
            (x * maxTilt).toFixed(2) +
            "deg) scale3d(1.02,1.02,1.02)";
        });
      });

      el.addEventListener("mouseleave", function () {
        if (raf) cancelAnimationFrame(raf);
        el.style.transform =
          "perspective(800px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)";
      });
    });
  }

  /* ---------- Bandeau de mots défilant (inspiré de Ganaé) -----------
     Reprend UNIQUEMENT des mots déjà présents sur la page (titre de la
     bannière d'accueil + intitulés des bénéfices) : aucun texte marketing
     n'est inventé ici, seule la mise en scène est empruntée. */
  function initMarquee() {
    if (prefersReducedMotion) return;
    if (window.location.pathname !== "/") return;
    if (document.querySelector(".mp-marquee")) return;

    var heroSection = document.querySelector('[id$="__image_banner"]');
    if (!heroSection) return;

    var words = [];
    var heading = heroSection.querySelector(".banner__heading");
    if (heading && heading.textContent) {
      heading.textContent
        .split(/[.!?]+/)
        .map(function (s) { return s.replace(/\s+/g, " ").trim(); })
        .filter(Boolean)
        .forEach(function (s) { words.push(s); });
    }

    var benefitHeadings = document.querySelectorAll(
      '[id$="__pp_image_with_benefits_YnG9hi"] .mp-icon-badge + div'
    );
    benefitHeadings.forEach(function (el) {
      var t = el.textContent.replace(/\s+/g, " ").trim();
      if (t && words.indexOf(t) === -1) words.push(t);
    });

    if (words.length < 3) return;

    var marquee = document.createElement("div");
    marquee.className = "mp-marquee";
    marquee.setAttribute("aria-hidden", "true");

    var track = document.createElement("div");
    track.className = "mp-marquee__track";

    function buildItems() {
      var frag = document.createDocumentFragment();
      words.forEach(function (w, i) {
        var item = document.createElement("span");
        item.className =
          "mp-marquee__item" + (i % 2 === 1 ? " mp-marquee__item--accent" : "");
        item.textContent = w;
        frag.appendChild(item);
        var dot = document.createElement("span");
        dot.className = "mp-marquee__dot";
        frag.appendChild(dot);
      });
      return frag;
    }

    track.appendChild(buildItems());
    marquee.appendChild(track);
    heroSection.insertAdjacentElement("afterend", marquee);

    /* L'animation translate la piste de -50% de SA PROPRE largeur, donc
       la boucle n'est parfaitement invisible que si "une moitié" de piste
       (une répétition des mots) est au moins aussi large que l'écran :
       sinon, juste avant que la boucle ne reprenne, la fenêtre visible
       dépasse le contenu réel et affiche un blanc (les mots "disparaissent"
       un instant) avant de se corriger au redémarrage de la boucle. On
       mesure donc la largeur réellement rendue et on répète les mots
       autant de fois que nécessaire pour dépasser largement la largeur de
       la fenêtre, puis on duplique ce bloc à l'identique pour la seconde
       moitié — garantissant une boucle parfaitement continue quel que
       soit le nombre de mots ou la largeur de l'écran. */
    var safety = 0;
    while (
      track.getBoundingClientRect().width < window.innerWidth * 1.15 &&
      safety < 25
    ) {
      track.appendChild(buildItems());
      safety++;
    }
    track.innerHTML += track.innerHTML;
  }

  /* ---------- Révélation progressive du texte au scroll -----------
     Inspiré du bloc "Des soins efficaces, sensoriels..." de Ganaé, où le
     texte s'éclaircit mot par mot pendant que la section défile. Appliqué
     au texte de mission déjà existant sur l'accueil ("La récupération
     musculaire, réinventée.") — le texte lui-même n'est pas modifié. */
  function initTextReveal() {
    if (prefersReducedMotion) return;

    var section = document.querySelector(
      '[id$="__pp_image_with_text_HNW9yr"]'
    );
    if (!section) return;
    if (section.dataset.mpTextRevealInit) return;
    section.dataset.mpTextRevealInit = "1";

    var targets = [];
    var heading = section.querySelector("h2");
    if (heading) targets.push(heading);
    var textBlock = section.querySelector('div[style*="color"]');
    if (textBlock) targets.push(textBlock);
    if (!targets.length) return;

    var words = [];
    targets.forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var textNodes = [];
      var n;
      while ((n = walker.nextNode())) {
        textNodes.push(n);
      }
      textNodes.forEach(function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return;
        var frag = document.createDocumentFragment();
        var parts = node.nodeValue.split(/(\s+)/);
        parts.forEach(function (part) {
          if (part.trim() === "") {
            frag.appendChild(document.createTextNode(part));
            return;
          }
          var span = document.createElement("span");
          span.className = "mp-word";
          span.textContent = part;
          frag.appendChild(span);
          words.push(span);
        });
        node.parentNode.replaceChild(frag, node);
      });
    });

    if (!words.length) return;

    function update() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;
      var start = vh * 0.85;
      var end = vh * 0.3;
      var range = start - end;
      var progress = range > 0 ? 1 - (rect.top - end) / range : 1;
      progress = Math.max(0, Math.min(1, progress));
      var litCount = Math.round(progress * words.length);
      words.forEach(function (w, i) {
        if (i < litCount) {
          w.classList.add("mp-word--lit");
        } else {
          w.classList.remove("mp-word--lit");
        }
      });
    }

    var ticking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            update();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  /* ---------- Minuteur panier (5 minutes) -----------
     Le panier Dawn re-rend intégralement .drawer__inner via AJAX à
     chaque ajout/suppression/modification (voir cart-drawer.js) : les
     éléments injectés par ce script sont donc détruits et recréés à
     chaque mutation. On interroge le DOM en direct à chaque tick au
     lieu de garder une référence, et on stocke l'heure d'expiration
     dans sessionStorage pour que le compte à rebours ne redémarre pas
     à chaque ouverture du tiroir — seulement quand le panier était
     vide juste avant. Le même minuteur est affiché à deux endroits
     (tiroir + page panier dédiée /cart) : on cible toutes les valeurs
     via la classe partagée .mp-cart-timer-value plutôt qu'un seul id. */
  function initCartTimer() {
    var STORAGE_KEY = "mp_cart_expires_at";
    var DURATION_MS = 5 * 60 * 1000;
    var clearing = false;

    function getStoredExpiry() {
      try {
        var v = window.sessionStorage.getItem(STORAGE_KEY);
        return v ? parseInt(v, 10) : null;
      } catch (e) {
        return null;
      }
    }

    function setStoredExpiry(value) {
      try {
        if (value === null) {
          window.sessionStorage.removeItem(STORAGE_KEY);
        } else {
          window.sessionStorage.setItem(STORAGE_KEY, String(value));
        }
      } catch (e) {
        /* stockage indisponible : le minuteur fonctionnera quand même
           pour la session en cours, simplement sans persistance */
      }
    }

    function expireCart() {
      if (clearing) return;
      clearing = true;
      setStoredExpiry(null);
      fetch("/cart/clear.js", { method: "POST" })
        .catch(function () {})
        .then(function () {
          window.location.reload();
        });
    }

    function tick() {
      var valueEls = document.querySelectorAll(".mp-cart-timer-value");
      var cartIsEmpty = !!document.querySelector(
        "cart-drawer.is-empty, cart-items.is-empty"
      );

      if (cartIsEmpty || !valueEls.length) {
        /* panier vide (ou minuteur pas encore rendu) : on efface toute
           expiration en cours pour repartir de zéro au prochain ajout */
        if (cartIsEmpty) setStoredExpiry(null);
        clearing = false;
        return;
      }

      var expiresAt = getStoredExpiry();
      if (!expiresAt) {
        expiresAt = Date.now() + DURATION_MS;
        setStoredExpiry(expiresAt);
      }

      var remainingMs = expiresAt - Date.now();
      if (remainingMs <= 0) {
        valueEls.forEach(function (el) {
          el.textContent = "00:00";
        });
        expireCart();
        return;
      }

      clearing = false;
      var totalSeconds = Math.ceil(remainingMs / 1000);
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      var display =
        (minutes < 10 ? "0" : "") + minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
      valueEls.forEach(function (el) {
        el.textContent = display;
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Avis produit en rotation automatique -----------
     Repère les blocs "pp-review" consécutifs via leur marquage interne
     (.pp-flex.pp-gap-6.pp-items-center, propre à ce type de bloc) sans
     nécessiter de modification du gabarit de section : quand plusieurs
     avis sont présents (fiche produit MyoPulse Mini), on masque tous
     sauf le premier puis on les fait défiler automatiquement toutes les
     9 secondes avec un léger fondu. Une seule carte : rien ne change. */
  function initReviewRotator() {
    var markers = document.querySelectorAll(".pp-flex.pp-gap-6.pp-items-center");
    var slides = [];
    markers.forEach(function (marker) {
      var wrap = marker.closest(".pagepilot-layout");
      if (wrap) slides.push(wrap);
    });

    if (slides.length < 2) return;

    var current = 0;
    slides.forEach(function (el, i) {
      if (i !== 0) el.style.display = "none";
    });

    if (prefersReducedMotion) return;

    setInterval(function () {
      slides[current].style.display = "none";
      current = (current + 1) % slides.length;
      slides[current].style.display = "";
      slides[current].classList.add("mp-review-fade");
      setTimeout(function () {
        slides[current].classList.remove("mp-review-fade");
      }, 500);
    }, 9000);
  }

  /* ---------- Estimation de livraison (fiches produit) -----------
     Bloc premium affiché à droite du sélecteur de quantité, sur toute
     fiche produit qui en possède un (sélecteur générique
     .product-form__quantity, commun à tous les gabarits produit — pas
     besoin de lister chaque produit un par un). On l'insère dans
     .price-per-item__container, le conteneur flex qui enveloppe déjà
     le stepper -/+ (ce dernier ne fait que ~140px de large dans un
     bloc qui en fait ~440 : il reste donc de la place à droite,
     naturellement, sans avoir à restructurer le bloc quantité). Si ce
     conteneur est absent sur un gabarit donné, on se rabat sur le bloc
     quantité lui-même. La fourchette de dates (aujourd'hui + 7 à + 8
     jours calendaires) est recalculée à chaque chargement de page à
     partir de la date du jour : elle s'actualise donc automatiquement
     chaque jour, sans intervention manuelle. */
  function initDeliveryEstimate() {
    var quantityBlocks = document.querySelectorAll(".product-form__quantity");
    if (!quantityBlocks.length) return;

    var MIN_DAYS = 7;
    var MAX_DAYS = 8;

    var monthNames = [
      "janvier", "février", "mars", "avril", "mai", "juin",
      "juillet", "août", "septembre", "octobre", "novembre", "décembre",
    ];

    var truckPath =
      "M255.42,117l-14-35A15.93,15.93,0,0,0,226.58,72H192V64a8,8,0,0,0-8-8H32A16,16,0,0,0,16,72V184a16,16,0,0,0,16,16H49a32,32,0,0,0,62,0h50a32,32,0,0,0,62,0h17a16,16,0,0,0,16-16V120A7.94,7.94,0,0,0,255.42,117ZM192,88h34.58l9.6,24H192ZM32,72H176v64H32ZM80,208a16,16,0,1,1,16-16A16,16,0,0,1,80,208Zm81-24H111a32,32,0,0,0-62,0H32V152H176v12.31A32.11,32.11,0,0,0,161,184Zm31,24a16,16,0,1,1,16-16A16,16,0,0,1,192,208Zm48-24H223a32.06,32.06,0,0,0-31-24V128h48Z";

    function addDays(date, days) {
      var d = new Date(date.getTime());
      d.setDate(d.getDate() + days);
      return d;
    }

    function formatRange(startDate, endDate) {
      var sameMonth =
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getFullYear() === endDate.getFullYear();

      if (sameMonth) {
        return (
          "Entre le <strong>" +
          startDate.getDate() +
          "</strong> et le <strong>" +
          endDate.getDate() +
          " " +
          monthNames[endDate.getMonth()] +
          "</strong>"
        );
      }

      return (
        "Entre le <strong>" +
        startDate.getDate() +
        " " +
        monthNames[startDate.getMonth()] +
        "</strong> et le <strong>" +
        endDate.getDate() +
        " " +
        monthNames[endDate.getMonth()] +
        "</strong>"
      );
    }

    var today = new Date();
    var rangeHTML = formatRange(addDays(today, MIN_DAYS), addDays(today, MAX_DAYS));

    quantityBlocks.forEach(function (block) {
      if (block.dataset.mpDeliveryInit) return;
      block.dataset.mpDeliveryInit = "1";

      var wrap = document.createElement("div");
      wrap.className = "mp-delivery-estimate";
      wrap.innerHTML =
        '<div class="mp-delivery-estimate__icon">' +
        '<svg class="mp-delivery-estimate__svg" viewBox="0 0 256 256" aria-hidden="true"><path d="' +
        truckPath +
        '"></path></svg>' +
        "</div>" +
        '<div class="mp-delivery-estimate__body">' +
        '<p class="mp-delivery-estimate__label">Livraison estimée</p>' +
        '<p class="mp-delivery-estimate__dates">' +
        rangeHTML +
        "</p>" +
        "</div>";

      var priceContainer = block.querySelector(".price-per-item__container");
      if (priceContainer) {
        priceContainer.appendChild(wrap);
      } else {
        block.insertAdjacentElement("afterend", wrap);
      }
    });
  }
})();
